import React from "react";
import { Routes, Route } from "react-router-dom";
import CorporateRentalDiscountList from "../Components/Corporate Rental Discount/corporateRentalDiscountList";

const CorporateRentalDiscountRoutes = () => {
    return (
        <Routes>
            <Route path="/corporate_rental_discount" element={<CorporateRentalDiscountList />} />
        </Routes>
    );
};

export default CorporateRentalDiscountRoutes;